import {
    NgModule
} from '@angular/core';
import {
    Routes,
    RouterModule
} from '@angular/router';
const routes: Routes = [{
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'mapbase',
        loadChildren: () =>
            import ('./MapBase/MapBase.module').then(m => m.MapBasePageModule),
    },
    {
        path: 'login',
        loadChildren: () =>
            import ('./Login/Login.module').then(m => m.LoginPageModule),
    },
    {
        path: 'itinerary',
        loadChildren: () =>
            import ('./Itinerary/Itinerary.module').then(m => m.ItineraryPageModule),
    },
    {
        path: 'mapbasebk',
        loadChildren: () =>
            import ('./MapBaseBK/MapBaseBK.module').then(m => m.MapBaseBKPageModule),
    },
    {
        path: 'home',
        loadChildren: () =>
            import ('./Home/Home.module').then(m => m.HomePageModule),
    },
];
@NgModule({
    imports: [RouterModule.forRoot(
        routes, {
            enableTracing: false,
            useHash: true
        }
    )],
    exports: [RouterModule]
})
export class AppRoutingModule {}